import { TEAMS_LINK_END_URL } from '@gokrew/models/constants';

/** The popup is its own window, so this never outlives it. */
const TEAMS_POPUP_RETURN_KEY = 'teams_popup_return';

function readPopupReturnUrl(search: string): string | null {
  const params = new URLSearchParams(search);
  if (params.get('popup') !== '1') return null;

  // Outlook and the Microsoft 365 app cannot hold a handle on the popup the
  // way Teams does, and substitute somewhere to navigate back to instead. An
  // unsubstituted placeholder still carries its braces.
  const hostRedirectUrl = params.get('hostRedirectUrl');
  if (!hostRedirectUrl || hostRedirectUrl.includes('{')) {
    return TEAMS_LINK_END_URL;
  }

  return `${TEAMS_LINK_END_URL}?hostRedirectUrl=${encodeURIComponent(
    hostRedirectUrl
  )}`;
}

/**
 * Call before redirecting to login: the redirect keeps the path but drops the
 * query, and with it the popup marker — leaving a finished link stranded on the
 * portal's success screen instead of reporting back to the host.
 */
export function rememberTeamsPopup(): void {
  const url = readPopupReturnUrl(window.location.search);
  if (url) sessionStorage.setItem(TEAMS_POPUP_RETURN_KEY, url);
}

/**
 * Where to send the browser instead of showing a success screen, when this
 * page was opened as a Teams link popup rather than a browser tab.
 *
 * The tab marks the URL it opens. A popup has to report its outcome back to
 * the host, which these portal pages cannot do — they carry no TeamsJS — so
 * they bounce to the backend page that can.
 */
export function teamsPopupReturnUrl(): string | null {
  return (
    readPopupReturnUrl(window.location.search) ??
    sessionStorage.getItem(TEAMS_POPUP_RETURN_KEY)
  );
}
